/* Won't Miss Garage payment adapter v0.1.0
   WMGPay.start({ amount, currency, description }) -> Promise<{ provider, id, status, payer }>
   Providers (Theme settings > Payments):
     simulate - opens a popup window with a fake "Pay" button so the whole flow can be tested with no charge.
                Falls back to an in-page modal if the popup is blocked.
     paypal   - PayPal Smart Buttons in a modal; the PayPal button opens PayPal's own popup and captures the order.
     none     - resolves immediately with status NOT_COLLECTED (order files without payment).
   Call start() synchronously inside a click/submit handler: the simulate popup must open in the user gesture. */
(function () {
  'use strict';
  var WMG = window.WMG = window.WMG || {};

  function config() { return (WMG.config && WMG.config.pay) || {}; }
  function currency() { return (WMG.config && WMG.config.currency) || 'USD'; }
  function fmt(amount, code) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount); }
    catch (e) { return code + ' ' + Number(amount).toFixed(2); }
  }
  function esc(s) { return WMG.esc ? WMG.esc(s) : String(s); }

  /* ----- in-page modal shell ----- */
  function openModal(opts) {
    var wrap = document.createElement('div');
    wrap.className = 'wmg-paymodal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.innerHTML =
      '<div class="wmg-paymodal__box">' +
        (opts.testNote ? '<p class="wmg-paymodal__test">' + esc(opts.testNote) + '</p>' : '') +
        '<p class="wmg-paymodal__amount">' + esc(fmt(opts.amount, opts.currency)) + '</p>' +
        '<p class="wmg-paymodal__desc">' + esc(opts.description || '') + '</p>' +
        '<div class="wmg-paymodal__buttons" data-wmg-pay-buttons></div>' +
        '<div class="wmg-paymodal__actions">' +
          (opts.showPay ? '<button type="button" class="wmg-btn wmg-btn--signal" data-wmg-pay-confirm>Pay now</button>' : '') +
          '<button type="button" class="wmg-btn wmg-btn--ghost" data-wmg-pay-cancel>Cancel</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    return {
      el: wrap,
      buttons: wrap.querySelector('[data-wmg-pay-buttons]'),
      confirm: wrap.querySelector('[data-wmg-pay-confirm]'),
      cancel: wrap.querySelector('[data-wmg-pay-cancel]'),
      close: function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    };
  }

  /* ----- simulate ----- */
  function simulate(opts) {
    var id = 'SIM-' + Date.now().toString(36).toUpperCase();
    var popup = null;
    try { popup = window.open('', 'WMGPay', 'popup=yes,width=440,height=560'); } catch (e) { popup = null; }

    if (popup && !popup.closed) {
      return new Promise(function (resolve, reject) {
        var doc = popup.document;
        doc.open();
        doc.write(
          '<!doctype html><html><head><meta charset="utf-8"><title>Test payment</title>' +
          '<style>body{font-family:system-ui,sans-serif;margin:0;padding:28px;background:#EDEEEB;color:#000}' +
          '.box{background:#fff;border:2px solid #000;padding:22px}h1{font-size:18px;margin:0 0 4px}' +
          '.amt{font-size:32px;font-weight:700;margin:12px 0 4px}.desc{color:#555;margin:0 0 20px}' +
          '.note{background:#F2C400;border:1px dashed #000;padding:6px 10px;font-size:13px;margin-bottom:16px}' +
          'button{width:100%;padding:14px;font-size:16px;font-weight:700;border:2px solid #000;cursor:pointer;margin-top:8px}' +
          '.pay{background:#D8262C;color:#fff;border-color:#D8262C}.cancel{background:#fff}</style></head><body>' +
          '<div class="box"><div class="note">Simulated payment. Nothing is charged.</div>' +
          '<h1>Won\'t Miss Garage</h1><div class="amt">' + esc(fmt(opts.amount, opts.currency)) + '</div>' +
          '<p class="desc">' + esc(opts.description || '') + '</p>' +
          '<button class="pay" id="pay">Pay now</button><button class="cancel" id="cancel">Cancel</button></div>' +
          '</body></html>'
        );
        doc.close();
        var done = false;
        doc.getElementById('pay').addEventListener('click', function () {
          done = true; popup.close();
          resolve({ provider: 'simulate', id: id, status: 'COMPLETED', payer: 'test@example.com' });
        });
        doc.getElementById('cancel').addEventListener('click', function () {
          done = true; popup.close();
          reject(new Error('Payment cancelled.'));
        });
        var poll = setInterval(function () {
          if (popup.closed) { clearInterval(poll); if (!done) reject(new Error('Payment window closed before paying.')); }
        }, 400);
      });
    }

    /* Popup blocked: same thing in a modal. */
    return new Promise(function (resolve, reject) {
      var m = openModal({ amount: opts.amount, currency: opts.currency, description: opts.description, showPay: true, testNote: 'Simulated payment (popup was blocked). Nothing is charged.' });
      m.confirm.addEventListener('click', function () { m.close(); resolve({ provider: 'simulate', id: id, status: 'COMPLETED', payer: 'test@example.com' }); });
      m.cancel.addEventListener('click', function () { m.close(); reject(new Error('Payment cancelled.')); });
    });
  }

  /* ----- PayPal ----- */
  var sdkPromise = null;
  function loadPayPal(clientId, code) {
    if (window.paypal && window.paypal.Buttons) return Promise.resolve(window.paypal);
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://www.paypal.com/sdk/js?client-id=' + encodeURIComponent(clientId) + '&currency=' + encodeURIComponent(code) + '&intent=capture&components=buttons';
      s.onload = function () { window.paypal ? resolve(window.paypal) : reject(new Error('PayPal SDK did not load.')); };
      s.onerror = function () { reject(new Error('PayPal SDK failed to load.')); };
      document.head.appendChild(s);
    });
    return sdkPromise;
  }

  function paypal(opts) {
    var clientId = config().paypalClientId;
    if (!clientId) return Promise.reject(new Error('PayPal is selected but no client ID is set in Theme settings > Payments.'));
    return new Promise(function (resolve, reject) {
      var m = openModal({ amount: opts.amount, currency: opts.currency, description: opts.description, showPay: false });
      m.cancel.addEventListener('click', function () { m.close(); reject(new Error('Payment cancelled.')); });
      loadPayPal(clientId, opts.currency).then(function (pp) {
        pp.Buttons({
          style: { layout: 'vertical', shape: 'rect', label: 'pay' },
          createOrder: function (data, actions) {
            return actions.order.create({
              purchase_units: [{ amount: { value: Number(opts.amount).toFixed(2), currency_code: opts.currency }, description: String(opts.description || '').slice(0, 127) }]
            });
          },
          onApprove: function (data, actions) {
            return actions.order.capture().then(function (details) {
              m.close();
              resolve({
                provider: 'paypal',
                id: details.id || data.orderID,
                status: details.status || 'COMPLETED',
                payer: details.payer && details.payer.email_address ? details.payer.email_address : ''
              });
            });
          },
          onCancel: function () { m.close(); reject(new Error('Payment cancelled.')); },
          onError: function (err) { m.close(); reject(err instanceof Error ? err : new Error('PayPal reported an error.')); }
        }).render(m.buttons);
      }).catch(function (err) { m.close(); reject(err); });
    });
  }

  window.WMGPay = {
    version: '0.1.0',
    provider: function () { return config().provider || 'simulate'; },
    start: function (opts) {
      opts = opts || {};
      var provider = this.provider();
      var amount = Number(opts.amount) || 0;
      var payload = { amount: amount, currency: opts.currency || currency(), description: opts.description || 'Won\'t Miss Garage order' };
      if (provider === 'none' || amount <= 0) {
        return Promise.resolve({ provider: 'none', id: '', status: 'NOT_COLLECTED', payer: '' });
      }
      if (provider === 'paypal') return paypal(payload);
      return simulate(payload);
    }
  };
})();
